import BaseModal from './BaseModal';

class WindowModal extends BaseModal {
  constructor(
    contentProvider,
    settings = {
      display_before_content_load: false,
    },
  ) {
    super(
      {
        overlay: document.querySelector('.js-modal-overlay'),
        modal_window: document.querySelector('.js-modal-window'),
        modal_content: document.querySelector('.js-modal-content'),
        close_button: document.querySelector('.js-modal-close'),
      },
      contentProvider,
      settings,
    );
  }
}

export default WindowModal;



// WEBPACK FOOTER //
// ./src/js/modals/WindowModal.js